import { data } from '../../svg/DriveFileMove/data';
import { makeIcon } from '../makeIcon';

export const DriveFileMove = makeIcon(data, 'drive_file_move', 'DriveFileMove');

export default DriveFileMove;
